import * as React from 'react';
import { cn } from '@/lib/utils';

interface Props extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange'> {
  value: number;
  onChange: (v: number) => void;
  min?: number;
  max: number;
  step?: number;
}

/**
 * 简化版 Slider — 基于原生 input[type=range]。生产可换 @radix-ui/react-slider。
 */
export const Slider = React.forwardRef<HTMLInputElement, Props>(
  ({ value, onChange, min = 0, max, step = 1, className, ...rest }, ref) => {
    return (
      <input
        ref={ref}
        type="range"
        value={value}
        min={min}
        max={max}
        step={step}
        onChange={(e) => onChange(Number(e.target.value))}
        className={cn('w-full h-2 cursor-pointer', className)}
        {...rest}
      />
    );
  },
);
Slider.displayName = 'Slider';
